import request from '@/common/utils/request.js'

// 登录
function login(as, bs) {
  return request({
    url: '/server/user/jxylogin',
    method: 'post',
    params: {
      username: as,
      password: bs
    }

  })
}
// 登录
function qrConnect(item) {
  return request({
    url: '/wechatDepart/servicer/qrConnect',
    method: 'GET',
    params: item

  })
}

export {
  login,
  qrConnect
}